import { useState } from 'react';
import {
    TiWarning,
    TiArrowSortedDown,
    TiArrowSortedUp
} from 'react-icons/ti';
import { PiWarningCircleFill } from "react-icons/pi";

import { Container } from './styled';


export function Error(props) {
    const { children, messageError } = props;
    const [isOpen, setIsOpen] = useState(true);

    if (!messageError) {
        return children;
    }

    return (
        <Container>
            <div className='children__'>
                {children}
            </div>
            <div className='action__'>
                <PiWarningCircleFill fontSize={'1.5rem'} />
                {'Não foi possível enviar essa mensagem'}
                <span
                    className='icon--'
                    onClick={() => setIsOpen(!isOpen)}
                >
                    {!isOpen ? <TiArrowSortedDown /> : <TiArrowSortedUp />}
                </span>
            </div>
            {isOpen &&
                <div className='error_msg'>
                    {messageError}
                </div>
            }
        </Container>
    );
}